// extracted by mini-css-extract-plugin
export default {"paper":"Header_paper__vMqRa"};